var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.194 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.194 19.5V21a2.254 2.254 0 0 1-2.258 2.25h-.753l-2.457 17.136a4.511 4.511 0 0 1-4.471 3.864H9.938a4.511 4.511 0 0 1-4.471-3.864L3.011 23.25h-.753A2.254 2.254 0 0 1 0 21v-1.5a2.254 2.254 0 0 1 2.258-2.25h6.336L18.64 3.486a3.007 3.007 0 0 1 4.87 3.529L16.04 17.25h22.114L30.683 7.015a3.007 3.007 0 0 1 4.87-3.529L45.6 17.25h6.336a2.254 2.254 0 0 1 2.258 2.25zM29.355 36V25.5a2.258 2.258 0 0 0-4.516 0V36a2.258 2.258 0 0 0 4.516 0zm10.538 0V25.5a2.258 2.258 0 0 0-4.516 0V36a2.258 2.258 0 0 0 4.516 0zm-21.076 0V25.5a2.258 2.258 0 0 0-4.516 0V36a2.258 2.258 0 0 0 4.516 0z",
    transform: "translate(0 -2.25)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBasket);
export default __webpack_public_path__ + "static/media/shoppingBasket.bc22210ed20836ceb37fdbb01d2831fd.svg";
export { ForwardRef as ReactComponent };